import { OptionProps } from 'typings/custom'

const states: Array<string> = [
  'AL',
  'AK',
  'AZ',
  'AR',
  'CA',
  'CO',
  'CT',
  'DE',
  'FL',
  'GA',
  'HI',
  'ID',
  'IL',
  'IN',
  'IA',
  'KS',
  'KY',
  'LA',
  'ME',
  'MD',
  'MA',
  'MI',
  'MN',
  'MS',
  'MO',
  'MT',
  'NE',
  'NV',
  'NH',
  'NJ',
  'NM',
  'NY',
  'NC',
  'ND',
  'OH',
  'OK',
  'OR',
  'PA',
  'RI',
  'SC',
  'SD',
  'TN',
  'TX',
  'UT',
  'VT',
  'VA',
  'WA',
  'WV',
  'WI',
  'WY'
]

const territories: Array<string> = [
  'AA',
  'AE',
  'AP',
  'AS',
  'DC',
  'GU',
  'MP',
  'PR',
  'VI'
]

const stateLists: Array<OptionProps> = states.map(state => ({
  label: state,
  value: state
}))

export const stateAndTerritoryList: Array<OptionProps> = states
  .concat(territories)
  .sort()
  .map(state => ({
    label: state,
    value: state
  }))

export const cities = {
  altamonteSprings: 'Altamonte Springs',
  atlanta: 'Atlanta',
  dallas: 'Dallas',
  elPaso: 'El Paso',
  orlando: 'Orlando',
  philadelphia: 'Philadelphia',
  shawneeMission: 'Shawnee Mission'
}

export const stateList = {
  florida: 'FL',
  georgia: 'GA',
  kansas: 'KS',
  pennsylvania: 'PA',
  texas: 'TX'
}

export default stateLists
